import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { DeletePaymentAccountsService } from "@/features/accounts/payment/scraping/services/delete-accounts-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useContext } from "react";


export const useDeletePaymentAccounts = () => {
  // グローバルエラーハンドリング
  const { setError } = useContext(ErrorDialogContext);

  // ローディング用コンテキスト
  const loadingCtx = useContext(LoadingModalContext);

  const deletePaymentAccountsService = new DeletePaymentAccountsService();

  /*--------------------
    イベント関連
  --------------------*/
  // 口座削除
  const deletePaymentAccounts = async (
    accountGroupId: string,
    paymentAccountId: string,
    paymentId: string,
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await deletePaymentAccountsService.deletePaymentAccounts({
        account_group_id: accountGroupId,
        payment_account_id: paymentAccountId,
        payment_id: paymentId,
      });
      return true;
    } catch (error) {
      // エラーハンドリング
      console.log("deletePaymentAccounts:", error);
      throw error;
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    deletePaymentAccounts: errorHandledAsync(deletePaymentAccounts, setError),
  };
};
